module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    directives: [{
      name: "highlight",
      rawName: "v-highlight"
    }],
    staticClass: "highlight"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-19873edc"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./client/components/highlight.vue
// module id = 272
// module chunks = 3